<template>
	<div
		class="conclusion-modal"
		:class="{'conclusion-modal--closed': closed}"
		role="dialog"
		aria-modal="true"
		:aria-hidden="closed ? 'true' : 'false'"
		@click.self="close"
	>
		<section class="conclusion-modal__content">
			<header class="conclusion-modal__header">
				<h2>{{title}}</h2>
				<button type="button" aria-label="Close" @click="close">&times;</button>
			</header>
			<div class="conclusion-modal__body">
				<p>{{message}}</p>
			</div>
		</section>
  </div>
</template>

<script>
import { translate } from '../../assets/translations';
export default {
	data(){
		return{
			closed: true,
			title: '',
			message: ''
		};
	},
  computed: {
    translation() {
      return translate(this.$store.state.language).conclusionModal
    }
  },
  methods:{
    open(success, title, message){
			this.buildResponse(success, title, message);
			this.closed = false;
    },
		openMessage(message){
			this.title = '';
			this.message = message;
			this.closed = false;
		},
    close(){
      this.closed = true;
    },
		buildResponse(success, title, message){
			if(success){
				this.title= title? title: this.translation.success.title;
				this.message= message? message: this.translation.success.message;
			}else{
				this.title= title? title: this.translation.fail.title;
				this.message= message? message: this.translation.fail.message;
			}
		}
  }
}
</script>
<style scoped lang="scss">
.conclusion-modal--closed {
  visibility: hidden;
  opacity: 0;
  pointer-events: none;
}

.conclusion-modal {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  z-index: 2000;
  inset: 0;
  padding: 9px;
  overflow-y: auto;
  background: rgba(0, 0, 0, .55);
  opacity: 1;
  transition: visibility .2s, opacity .2s linear;
}

.conclusion-modal__content {
  width: 100%;
  max-width: 560px;
  overflow: hidden;
  border-radius: 13px;
  background: #ffffff;
  box-shadow: 0 18px 45px rgba(0, 0, 0, .25);
}

.conclusion-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 53px;
  padding: 0 11px 0 20px;
  background: #67adc6;
  color: #ffffff;
}

.conclusion-modal__header h2 {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
}

.conclusion-modal__header button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #ffffff;
  font-size: 26px;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
}

.conclusion-modal__header button:focus-visible {
  outline: 2px solid #ffffff;
  outline-offset: -4px;
}

.conclusion-modal__body {
  box-sizing: border-box;
  min-height: 97px;
  padding: 24px;
  color: #4c4b4b;
}

.conclusion-modal__body p {
  margin: 0;
  line-height: 1.5;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/ConclusionModal.vue